import { useMemo } from 'react';
import AuthService from '../services/authservices';

export function useAdmin(): boolean {
  const authService = useMemo(() => new AuthService(), []);
  const user = authService.getStoredUser<Record<string, unknown> | null>();
  return !!user && user.team_admin === true;
}
